module.exports = __webpack_public_path__ + "img/horizontal_7_5_3009.c450e607.png";